import allSettled from 'promise.allsettled';
import promiseFinally from 'promise.prototype.finally';

export default function shim() {
  promiseFinally.shim();
  allSettled.shim();
}
